import { useToggle } from "client/hooks/utils/useToggle";
import { useColorPickerButton as usePickColor } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Color/ColorList/ColorPickerButton/useColorPickerButton";
import { Mode } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Color/types";
import { useState } from "react";
import { TextBox } from "store/features/memeGenerator/types";

export const useColorPickerButton = (textBox: TextBox, mode: Mode) => {
    const { isOpen, toggle, onClose: close } = useToggle();
    const [color, setColor] = useState("");
    const { handleColorChange } = usePickColor(textBox, mode);
    function approve(color: string) {
        close();
        handleColorChange(color);
    }
    return {
        color,
        setColor,
        isOpen,
        toggle,
        close,
        approve,
    };
};
